import { Component, input } from '@angular/core';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-loading-container',
  imports: [MatProgressSpinner],
  template: `
    @if (loading()) {
      <mat-spinner [diameter]="size()"></mat-spinner>
    } @else {
      <ng-content />
    }
  `,
  styles: `
    :host {
      display: flex;
      justify-content: center;
      position: relative;
    }
  `,
})
export class LoadingContainerComponent {
  loading = input.required<boolean>();
  size = input<number>(40);
}
